<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="phone">
          <iframe src="http://mobileweb.yurencloud.com/#/modal" frameborder="0" width="320" height="580"></iframe>
        </div>


        <div class="title">对话框</div>
        <div class="sub-title">普通用法</div>
        <pre v-highlightjs="code1"><code class="html" ></code></pre>
        <pre v-highlightjs="code2"><code class="javascript" ></code></pre>

        <div class="sub-title">属性</div>
        <yu-table :data="attributes1" :widths="widths1"/>

        <div class="sub-title">事件</div>
        <yu-table :data="attributes2" :widths="widths2"/>

      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuTable } from 'yu.ui';
import { YuButton, YuText } from 'yu.mobile';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Buttons',
  data() {
    return {
      code1: `
  <yu-text>
    <yu-button fluid @click="activeModal">打开对话框</yu-button>
  </yu-text>
  <yu-modal ref="modal" title="我是标题">
    我是内容
  </yu-modal>
      `,
      code2: `
  import { YuModal, YuText, YuButton } from 'yu.mobile';

  export default {
    name: 'HelloWorld',
    methods: {
      to(url) {
        this.$router.push(url)
      },
      activeModal() {
        this.$refs.modal.visible = true;
      },
    },
    components: {
      YuButton,
      YuModal,
      YuText,
    },
  };
      `,
      attributes1: [
        {
          prop: '参数',
          description: '说明',
          types: '类型',
          default: '默认值',
        },
        {
          prop: 'title',
          description: '对话框标题',
          types: 'String',
          default: '无',
        },
        {
          prop: 'button',
          description: '确定按钮文字',
          types: 'String',
          default: '确定',
        },
      ],
      attributes2: [
        {
          event: '事件名称',
          description: '说明',
          callback: '回调参数',
        },
        {
          event: 'cancel',
          description: '取消对话框点击事件',
          callback: '无',
        },
        {
          event: 'confirm',
          description: '确定对话框点击事件',
          callback: '无',
        },
      ],
      widths1: {
        prop: '150px',
        description: '300px',
        types: '120px',
        default: '200px',
      },
      widths2: {
        event: '150px',
        description: '300px',
        callback: '320px',
      },
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuTable,
    YuButton,
    YuText,
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }

    .phone{
      text-align: center;
      iframe {
        margin: 20px auto;
        border-radius: 20px;
        &::-webkit-scrollbar {
          width: 0;
        }
        border: 10px solid $border;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modal.vue